import {
  Button,
  Container,
  Grid,
  Loader,
  Modal,
  Switch,
  TextInput,
  Title,
} from "@mantine/core";
import { showNotification, updateNotification } from "@mantine/notifications";
import { useEffect, useState } from "react";
import {
  fetchSettingsApi,
  addDomainApi,
  handleSettingApi,
  setAssignmentApi,
} from "../api/settings";

async function fetchSettings() {
  try {
    const res = await fetchSettingsApi().catch((err) => {
      showNotification({
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if (err.data.message !== "Invalid pin") {
          localStorage.clear();
          window.location.replace("/");
        }
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      showNotification({
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      showNotification({
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });

      return [];
    }
  } catch (error) {
    //console.log(error);
  }
}

async function assign(data, notificationid) {
  try {
    const res = await setAssignmentApi(data).catch((err) => {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if (err.data.message !== "Invalid pin") {
          localStorage.clear();
          window.location.replace("/");
        }
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      //console.log(res);
      return [];
    }
  } catch (error) {
    updateNotification({
      id: notificationid,
      title: "ERROR",
      message: error.response.data.message,
      color: "red",
    });
  }
}

async function addDomainFunc(data, notificationid) {
  try {
    const res = await addDomainApi(data).catch((err) => {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if (err.data.message !== "Invalid pin") {
          localStorage.clear();
          window.location.replace("/");
        }
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (error) {
    updateNotification({
      id: notificationid,
      title: "ERROR",
      message: error.response.data.message,
      color: "red",
    });
  }
}

async function updateSetting(data, notificationid) {
  try {
    const res = await handleSettingApi(data).catch((err) => {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if (err.data.message !== "Invalid pin") {
          localStorage.clear();
          window.location.replace("/");
        }
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (error) {
    updateNotification({
      id: notificationid,
      title: "ERROR",
      message: error.response.data.message,
      color: "red",
    });
  }
}

const settingNames = {
  isRegistrationOpen: "Toggle Registration",
  IsMentorMenteeAssigned: "Assign Mentor Mentee",
};

export default function Settings() {
  const [domain, setDomain] = useState("");
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [adminKey, setadminKey] = useState("");
  // const [func, setFunc] = useState();
  const [functionParams, setFunctionParams] = useState();
  const [isSwitch, setIsSwitch] = useState(false);

  useEffect(() => {
    fetchSettings().then((res) => {
      setSettings(res.data);
      setLoading(false);
    });
  }, []);

  const addDomain = () => {
    showNotification({
      id: "add-domain",
      title: "Adding Domain",
      loading: true,
      autoClose: false,
      disallowClose: true,
    });
    addDomainFunc({ name: domain, adminPin: adminKey }, "add-domain")
      .then((res) => {
        if (Object.keys(res).length) {
          updateNotification({
            id: "add-domain",
            title: "SUCCESS",
            message: res.message,
            color: "green",
          });
          setDomain("");
          setadminKey("");
          setModalOpen(false);
        }
      })
      .catch(() => {
        setadminKey("");
      });
  };

  const handleSetting = (data) => {
    const id = data.id;
    const name = data.name;
    showNotification({
      id,
      loading: true,
      title: "Updating Setting " + name,
      autoClose: false,
      disallowClose: true,
    });
    let settingIndex = settings.findIndex((obj) => obj.id == id);
    updateSetting(
      {
        settingId: settings[settingIndex].id,
        value: settings[settingIndex].value,
        adminPin: adminKey,
      },
      id
    )
      .then((res) => {
        if (typeof res !== "undefined" && Object.keys(res).length) {
          updateNotification({
            id,
            title: "SUCCESS",
            message: "Setting updated successfully",
            color: "green",
          });
          setadminKey("");
          setModalOpen(false);
        }
      })
      .catch(() => {
        setadminKey("");
      });
  };

  const toggleSwitch = (data) => {
    const checked = data.checked;
    // console.log(checked);
    const setting = data.setting;
    if (!checked && setting.name === "IsMentorMenteeAssigned") {
      showNotification({
        id: setting.id,
        title: "Cannot Toggle IsMentorMenteeAssigned once set",
        color: "red",
      });
      setModalOpen(false);
      return;
    }
    showNotification({
      id: setting.id,
      loading: true,
      title: "Updating Setting " + setting.name,
      autoClose: false,
      disallowClose: true,
    });
    var settingId = setting.id;
    if (setting.name === "IsMentorMenteeAssigned") {
      assign({ adminPin: adminKey }, setting.id)
        .then((res) => {
          if (typeof res !== "undefined" && Object.keys(res).length) {
            updateNotification({
              id: setting.id,
              title: "SUCCESS",
              message: "Assignment Done",
              color: "green",
            });
          }
          setadminKey("");
          setSettings((prevSettings) => {
            const updatedSettings = prevSettings.map((s) =>
              s.id === settingId ? { ...s, enabled: checked } : s
            );
            return updatedSettings;
          });
          setModalOpen(false);
        })
        .catch(() => {
          setadminKey("");
        });
    } else {
      updateSetting(
        {
          settingId: setting.id,
          adminPin: adminKey,
        },
        setting.id
      )
        .then((res) => {
          if (typeof res !== "undefined" && Object.keys(res).length) {
            updateNotification({
              id: setting.id,
              title: "SUCCESS",
              message: "Setting " + setting.name + "Updated Successfully",
              color: "green",
            });
            setadminKey("");
            setSettings((prevSettings) => {
              const updatedSettings = prevSettings.map((s) =>
                s.id === settingId ? { ...s, enabled: checked } : s
              );
              return updatedSettings;
            });
            setModalOpen(false);
          }
        })
        .catch(() => {
          setadminKey("");
        });
    }
  };

  const modalHandler = () => {
    if (isSwitch === "switch") {
      toggleSwitch(functionParams);
    } else if (isSwitch === "domain") {
      addDomain();
    } else {
      handleSetting(functionParams);
    }
  };

  // const modalFun = (functiontopass, data) => {
  //   setModalOpen(true);
  //   setFunctionParams(data);
  //   setFunc(() => functiontopass);
  // };

  return (
    <Container>
      <Title order={1}>Settings</Title>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Modal
            opened={modalOpen}
            onClose={() => setModalOpen(false)}
            title="Enter Admin Pin"
          >
            <TextInput
              placeholder="Enter Admin Key To Continue"
              value={adminKey}
              onChange={(event) => setadminKey(event.currentTarget.value)}
            />
            <br></br>
            <Button
              style={{ width: 100, float: "right" }}
              onClick={() => {
                // setFunctionParams({
                //   ...functionParams,
                //   adminPin: adminKey,
                // });
                // modalFun(func, functionParams);
                // func(functionParams);
                modalHandler();
              }}
            >
              Submit
            </Button>
          </Modal>
          <Grid justify="center">
            {settings.map((setting) => (
              <Container
                key={setting.id}
                style={{
                  padding: 16,
                  margin: 16,
                  border: "2px solid #ddd",
                  borderRadius: 8,
                }}
              >
                <Title order={6}>
                  {settingNames[setting.name]
                    ? settingNames[setting.name]
                    : setting.name}
                </Title>
                <br></br>
                {setting.name === "firstYearRoll" ||
                setting.name === "maxDomainCount" ? (
                  <TextInput
                    placeholder="Value here"
                    value={setting.value}
                    onChange={(event) => {
                      let value = event.currentTarget.value;
                      let settingId = setting.id;
                      setSettings((prevSettings) => {
                        const updatedSettings = prevSettings.map((s) =>
                          s.id === settingId
                            ? { ...s, value }
                            : s
                        );
                        return updatedSettings;
                      });
                    }}
                  />
                ) : (
                  <Switch
                    label="Switch"
                    onLabel="ON"
                    offLabel="OFF"
                    checked={
                      settings[
                        settings.findIndex((obj) => obj.id == setting.id)
                      ].enabled
                    }
                    onChange={(event) => {
                      setFunctionParams({
                        checked: event.currentTarget.checked,
                        setting,
                      });
                      setIsSwitch("switch");
                      setModalOpen(true);
                      // modalFun(toggleSwitch, );
                    }}
                  />
                )}
                <br></br>
                {setting.name === "firstYearRoll" ||
                setting.name === "maxDomainCount" ? (
                  <Button
                    onClick={() => {
                      setFunctionParams({
                        id: setting.id,
                        name: setting.name,
                      });
                      setIsSwitch("field");
                      setModalOpen(true);
                      // modalFun(handleSetting, )
                    }}
                  >
                    Update Setting
                  </Button>
                ) : null}
              </Container>
            ))}

            <Container
              style={{
                padding: 16,
                margin: 16,
                border: "2px solid #ddd",
                borderRadius: 8,
              }}
            >
              <Title order={6}>Add a New Domain</Title>
              <br></br>
              <TextInput
                placeholder="Name of the Domain"
                value={domain}
                onChange={(event) => setDomain(event.currentTarget.value)}
              />
              <br></br>
              <Button
                onClick={() => {
                  setIsSwitch("domain");
                  setModalOpen(true);
                }}
              >
                Add Domain
              </Button>
            </Container>
          </Grid>
        </>
      )}
    </Container>
  );
}
